import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Dashboard() {
  const [status, setStatus] = useState(null);
  const [options, setOptions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statusData, optionsData] = await Promise.all([
          api.get('/status'),
          api.get('/config/options'),
        ]);
        setStatus(statusData);
        setOptions(optionsData);
      } catch (err) {
        console.error('Failed to fetch dashboard data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <div className="card">Loading...</div>;

  return (
    <div>
      <div className="page-header">
        <h2>Dashboard</h2>
        <p>L2Walker Web Control Panel overview</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{status?.uptimeFormatted || '0h 0m 0s'}</div>
          <div className="stat-label">Server Uptime</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{options?.Options?.Server || 'N/A'}</div>
          <div className="stat-label">Connected Server</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{options?.Options?.Title || 'L2Walker'}</div>
          <div className="stat-label">Version</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{status?.platform || 'N/A'}</div>
          <div className="stat-label">Platform</div>
        </div>
      </div>

      <div className="card">
        <div className="card-title">Server Information</div>
        <table className="table">
          <tbody>
            <tr>
              <td>Memory Usage (RSS)</td>
              <td>{status?.memory ? `${(status.memory.rss / 1024 / 1024).toFixed(1)} MB` : 'N/A'}</td>
            </tr>
            <tr>
              <td>Memory Usage (Heap)</td>
              <td>{status?.memory ? `${(status.memory.heapUsed / 1024 / 1024).toFixed(1)} MB` : 'N/A'}</td>
            </tr>
            <tr>
              <td>CPU Load (1m avg)</td>
              <td>{status?.cpu?.[0]?.toFixed(2) || 'N/A'}</td>
            </tr>
            <tr>
              <td>GM Fix</td>
              <td>
                <span className={`status-badge ${options?.Options?.GMFix === '1' ? 'status-online' : 'status-offline'}`}>
                  {options?.Options?.GMFix === '1' ? 'Enabled' : 'Disabled'}
                </span>
              </td>
            </tr>
            <tr>
              <td>Rename</td>
              <td>
                <span className={`status-badge ${options?.Options?.Rename === '1' ? 'status-online' : 'status-offline'}`}>
                  {options?.Options?.Rename === '1' ? 'Enabled' : 'Disabled'}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Dashboard;
